var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EFF3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3734 26.3613C39.2801 26.348 39.1867 26.348 39.0934 26.3613C37.0267 26.2946 35.3867 24.6013 35.3867 22.5213C35.3867 20.4013 37.1067 18.668 39.2401 18.668C41.3601 18.668 43.0934 20.388 43.0934 22.5213C43.0801 24.6013 41.4401 26.2946 39.3734 26.3613Z",
    fill: "#002C8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7205 35.6005C42.2271 36.6005 40.1338 36.9739 38.2005 36.7205C38.7071 35.6272 38.9738 34.4139 38.9871 33.1339C38.9871 31.8005 38.6938 30.5339 38.1338 29.4272C40.1071 29.1605 42.2005 29.5339 43.7071 30.5339C45.8138 31.9205 45.8138 34.2005 43.7205 35.6005Z",
    fill: "#002C8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5865 26.3613C24.6799 26.348 24.7732 26.348 24.8665 26.3613C26.9332 26.2946 28.5732 24.6013 28.5732 22.5213C28.5732 20.388 26.8532 18.668 24.7199 18.668C22.5999 18.668 20.8799 20.388 20.8799 22.5213C20.8799 24.6013 22.5199 26.2946 24.5865 26.3613Z",
    fill: "#002C8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7335 33.1341C24.7335 34.4275 25.0135 35.6541 25.5202 36.7608C23.6402 36.9608 21.6802 36.5608 20.2402 35.6141C18.1335 34.2141 18.1335 31.9341 20.2402 30.5341C21.6668 29.5741 23.6802 29.1875 25.5735 29.4008C25.0268 30.5208 24.7335 31.7875 24.7335 33.1341Z",
    fill: "#002C8F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1604 37.16C32.0537 37.1467 31.9337 37.1467 31.8137 37.16C29.3604 37.08 27.4004 35.0667 27.4004 32.5867C27.4137 30.0533 29.4537 28 32.0004 28C34.5337 28 36.5871 30.0533 36.5871 32.5867C36.5737 35.0667 34.6271 37.08 32.1604 37.16Z",
    fill: "#002C8F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8264 39.9195C25.8131 41.2662 25.8131 43.4795 27.8264 44.8129C30.1197 46.3462 33.8797 46.3462 36.1731 44.8129C38.1864 43.4662 38.1864 41.2529 36.1731 39.9195C33.8931 38.3862 30.1331 38.3862 27.8264 39.9195Z",
    fill: "#002C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc1);
export default __webpack_public_path__ + "static/media/ic1.4ace0b2c97b0f049b3b2e0d3519366f5.svg";
export { ForwardRef as ReactComponent };